export default __webpack_public_path__ + "static/media/cb-returnss-policy.2b87b91d.png";